// extracted by mini-css-extract-plugin
export default {"tvSeasonsTabs":"styles_tvSeasonsTabs__xxyV1","header":"styles_header__YBoPL","tabs":"styles_tabs__mMIiJ","button":"styles_button__wYVNr","active":"styles_active__gZaDD"};